const phoneValidation = function(phone) {
  return !phone ||
    phone.match(
      /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4})$/
    )
    ? true
    : false
}

const allowedTypes = [
  'text/plain',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'image/png',
  'image/jpeg'
]

const fileTypeValidation = function(file) {
  return file != null && allowedTypes.includes(file.type)
}

const passwordValidation = function(password) {
  return !password ||
    password.match(
      // (?=.*[a-z]): must contain a lowercase letter
      // (?=.*[A-Z]): must contain an uppercase letter
      // (?=.*\d): must contain a digit
      // (?=.*[!@#$ %^&*?]): must contain at least one of these special characters
      // [A-Za-z\d!@#$ %^&*?]: only allows uppercase / lowercase letters, digits, and the listed symbols
      // {15,60}: length 15 to 60 characters
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*?])[A-Za-z\d!@#$%^&*?]{15,60}$/
    )
    ? true
    : false
}

export default {
  phoneValidation,
  fileTypeValidation,
  passwordValidation
}
